export function isComponentTypeOf(child, type) {
  return child.type === type;
}
